module.exports = __webpack_public_path__ + "img/samplering.5f4987d.webp";